<template>
  <div class="comparison-container">
    <v-card
      class="comparison-card mx-auto p-relative mb-5"
      :class="showCompareForm ? 'white' : 'bg0'"
    >
      <template v-if="!showCompareForm">
        <!-- header -->
        <div
          class="row-flex header"
        >
          <VehicleHeader
            :class="(!firstVehicle.id && !secondVehicle.id) && 'with-border'"
            @onAdd="showCompareForm = true"
            @onRemove="onRemove($event)"
            :vehicle="firstVehicle"
          />
          <VehicleHeader
            class="meta-right"
            @onAdd="showCompareForm = true"
            @onRemove="onRemove($event)"
            :vehicle="secondVehicle"
          />
        </div>
        <!-- actions -->
        <div v-if="toCompare.length > 0" class="row-flex actions pt-3 pb-5 white">
          <div class="flex-center-content">
            <v-btn
              class="action-btn white--text" color="#228B22"
              :disabled="!firstVehicle.id"
              @click="$router.push('/order/' + firstVehicle.id)"
            >
              Bestellen
            </v-btn>
          </div>
          <div class="flex-center-content">
            <v-btn
              class="action-btn white--text" color="#228B22"
              :disabled="!secondVehicle.id"
              @click="$router.push('/order/' + secondVehicle.id)"
            >
              Bestellen
            </v-btn>
          </div>
        </div>
        <!-- comparison factors  -->
        <div v-if="toCompare.length > 0" class="px-4 factors pb-4 pt-10 white">
          <div class="col-flex size-18 factor">
            <div class="text-center mt-3">Preis</div>
            <div class="col-flex mt-2 mb-3">
              <div class="row-flex justify-space-between ">
                <div :class="isBetter(true, 'ourPrice', true)">{{(firstVehicle.ourPrice || 0) | priceFormat}} €</div>
                <div :class="isBetter(false, 'ourPrice', true)">{{(secondVehicle.ourPrice || 0) | priceFormat}} €</div>
              </div>
            </div>
          </div>
          <div class="col-flex size-18 factor">
            <div class="text-center mt-3">Reichweite</div>
            <div class="row-flex justify-space-between mt-2 mb-3">
              <div :class="isBetter(true, 'reach')">{{firstVehicle.reach || 0}} km</div>
              <div :class="isBetter(false, 'reach')">{{secondVehicle.reach || 0}} km</div>
            </div>
          </div>
          <div class="col-flex size-18 factor">
            <div class="text-center mt-3">Geschwindigkeit</div>
            <div class="row-flex justify-space-between mt-2 mb-3">
              <div :class="isBetter(true, 'speed')">{{firstVehicle.speed || 0}} km/h</div>
              <div :class="isBetter(false, 'speed')">{{secondVehicle.speed || 0}} km/h</div>
            </div>
          </div>
          <div class="col-flex size-18 factor">
            <div class="text-center mt-3">Modell</div>
            <div class="row-flex justify-space-between mt-2 mb-3">
              <div :class="firstVehicle.id && 'font-weight-bold'">
                {{firstVehicle.modell || 'unknown'}}
              </div>
              <div :class="secondVehicle.id && 'font-weight-bold'">
                {{secondVehicle.modell || 'unknown'}}
              </div>
            </div>
          </div>
          <div class="col-flex size-18 factor">
            <div class="text-center mt-3">Beschleunigung</div>
            <div class="row-flex justify-space-between mt-2 mb-3">
              <div :class="isBetter(true, 'acceleration', true)">
                {{
                  firstVehicle.acceleration ?
                  Number(firstVehicle.acceleration).toLocaleString('DE') + ' s' :
                  'unknown'
                }}
              </div>
              <div :class="isBetter(false, 'acceleration', true)">
                {{
                  secondVehicle.acceleration ?
                  Number(secondVehicle.acceleration).toLocaleString('DE') + ' s' :
                   'unknown'
                }}
            </div>
            </div>
          </div>
          <div class="col-flex size-18 factor">
            <div class="text-center mt-3">Verbrauch</div>
            <div class="row-flex justify-space-between mt-2 mb-3">
              <div :class="isBetter(true, 'motor', true)">{{(firstVehicle.motor || 0) | motorFormat}}</div>
              <div :class="isBetter(false, 'motor', true)">{{(secondVehicle.motor || 0) | motorFormat}}</div>
            </div>
          </div>
          <div class="col-flex size-18 factor">
            <div class="text-center mt-3">Leistung</div>
            <div class="row-flex justify-space-between mt-2 mb-3">
              <div :class="isBetter(true, 'range')">{{firstVehicle.range | powerFormat}}</div>
              <div :class="isBetter(false, 'range')" align="right">{{secondVehicle.range | powerFormat}}</div>
            </div>
          </div>
          <div class="col-flex size-18 factor">
            <div class="text-center mt-3">Sitzplätze</div>
            <div class="row-flex justify-space-between mt-2 mb-3">
              <div :class="isBetter(true, 'seats')">{{(firstVehicle.seats || 0)}}</div>
              <div :class="isBetter(false, 'seats')">{{(secondVehicle.seats || 0)}}</div>
            </div>
          </div>
          <div class="col-flex size-18 factor">
            <div class="text-center mt-3">Laderaum</div>
            <div class="row-flex justify-space-between mt-2 mb-3">
              <div :class="isBetter(true, 'loading')">{{(firstVehicle.loading || 0) | loadingFormat}}</div>
              <div :class="isBetter(false, 'loading')">{{(secondVehicle.loading || 0) | loadingFormat}}</div>
            </div>
          </div>
        </div>
      </template>
      <!-- to compare -->
      <ToCompare @closeForm="showCompareForm = false" v-else />
    </v-card>
  </div>
</template>

<script>
import vehicles from '@/api/vehicles.json'
import VehicleHeader from '@/components/comparison/VehicleHeader'
import ToCompare from '@/components/comparison/ToCompare'

export default {
  name: 'comparison',
  components: {
    VehicleHeader,
    ToCompare
  },
  computed: {
    toCompare: function() {
      return this.$store.state.toCompare;
    },
    firstVehicle: function() {
      let id = this.$store.state.firstVehicle;
      
      if(!id)
        return {};

      return vehicles.find(vehicle => vehicle.id === id);
    },
    secondVehicle: function() {
      let id = this.$store.state.secondVehicle;
      
      if(!id)
        return {};

      return vehicles.find(vehicle => vehicle.id === id);
    }
  },
  data: () => ({
    showCompareForm: false
  }),
  methods: {
    onRemove(vehicle) {
      this.$store.commit("REMOVE_FROM_COMPARISON", vehicle.id);
    },
    isBetter(first, prop, lowerBetter = false) {
      let boldClass = "font-weight-bold";
      let {firstVehicle, secondVehicle} = this;
      
      let val1 = firstVehicle[prop];
      let val2 = secondVehicle[prop];

      // for array values
      if(typeof val1 === 'object') {
        val1 = val1 ? val1[0] : undefined;
        val2 = val2 ? val2[0] : undefined;
      }

      if(val1 === val2) return boldClass;
      
      if(!lowerBetter)
      {
        if(first)
          return !val2 || val1 > val2 ? boldClass : '';
        if(!first)
          return !val1 || val1 < val2 ? boldClass : '';
      }
      else {
        if(first)
          return !val2 || val1 < val2 ? boldClass : '';
        if(!first)
          return !val1 || val1 > val2 ? boldClass : '';
      }
    },
    isSavingMore(first) {
      let boldClass = "font-weight-bold";
      let {firstVehicle, secondVehicle} = this;

      if(first) {
        if(!secondVehicle.id) return boldClass;

        let saving1 = firstVehicle.ourPrice/firstVehicle.listPrice;
        let saving2 = secondVehicle.ourPrice/secondVehicle.listPrice;

        return saving1 < saving2 ? boldClass : '';
      }
      else {
        if(!firstVehicle.id) return boldClass;

        let saving1 = firstVehicle.ourPrice/firstVehicle.listPrice;
        let saving2 = secondVehicle.ourPrice/secondVehicle.listPrice;

        return saving1 > saving2 ? boldClass : '';
      }

    }
  },
  filters: {
    priceFormat(val) {
      if(!val)
        return val;
      return Number(val).toLocaleString('DE');
    },
    percentageFormat(val) {
      if(!val.id)
        return 0;
      return (100 - (val.ourPrice/val.listPrice * 100)).toFixed(0);
    },
    motorFormat(val) {
      if(!val)
        return val;
      return (val + '').replace(/\./g, ',') + ' kWh';
    },
    loadingFormat(val) {  
      if(!val)
        return val;
      return val + " l";
    },
    rechargeFormat(val) {
      if(!val) return `0km in 0mins`;
      return `${val[0]}km in ${val[1]}mins`;
    },
    powerFormat(val) {
      if(!val) return `0 kW`;
      return `${val} kW`;
    },
  }
}
</script>

<style lang="scss">
.comparison-container {
  padding-top: 110px;
  background: linear-gradient(33.53deg, #022239 0%, #030E30 100%);
  background-size: 100% 275px;
  background-repeat: no-repeat;
  background-attachment: fixed;

  .comparison-card {
    width: 95%;
    border-radius: 14px !important;
    overflow: hidden;

    .header {
      height: 265px;
      // background-color: #E2E7EA;

      .with-border {
        border-right: 1px solid rgb(177, 177, 177);
      }
    }
    .actions {

      > div {
        flex-grow: 1;
      }
      .action-btn {
        width: 138px;
        height: 50px;
        background-color: #228B22;
        box-shadow: 0px 2px 7px rgba(80, 80, 80, 0.118854);
        border-radius: 25px;
      }
    }
    .factors .factor {
      border-bottom: 1px solid #9FAEB8;
    }
    .factors .factor:first-child {
      border-top: 1px solid #9FAEB8;
    }
  }
}
</style>